export const EMPLOYEES_TABLE_KEYS = {
    FIRST_NAME: "firstName",
    LAST_NAME: "lastName",
    EMAIL: "email",
    EMPLOYEE_CODE: "employeeCode",
    DESIGNATION: "designation",
    DEPARTMENT: "department",
    EDIT: "edit"
}

export const EMPLOYEES_TABLE_HEADER = {
    [EMPLOYEES_TABLE_KEYS.FIRST_NAME]: "First Name",
    [EMPLOYEES_TABLE_KEYS.LAST_NAME]: "Last Name",
    [EMPLOYEES_TABLE_KEYS.EMAIL]: "Email Address",
    [EMPLOYEES_TABLE_KEYS.EMPLOYEE_CODE]: "Employee Code",
    [EMPLOYEES_TABLE_KEYS.DESIGNATION]: "Designation",
    [EMPLOYEES_TABLE_KEYS.DEPARTMENT]: "Department",
    [EMPLOYEES_TABLE_KEYS.EDIT]: "Edit Status",
}

export const employeesTableData = Array.from({ length: 10 }, (element, index) => {
    return {
        [EMPLOYEES_TABLE_KEYS.FIRST_NAME]: "Pradumna",
        [EMPLOYEES_TABLE_KEYS.LAST_NAME]: "Vatsa",
        [EMPLOYEES_TABLE_KEYS.EMAIL]: "pradumna.vatsa@jaspercolin.com",
        [EMPLOYEES_TABLE_KEYS.EMPLOYEE_CODE]: "285",
        [EMPLOYEES_TABLE_KEYS.DESIGNATION]: "designation",
        [EMPLOYEES_TABLE_KEYS.DEPARTMENT]: "department",
        [EMPLOYEES_TABLE_KEYS.IS_ACTIVE]: true
    }
})